import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = { //en
    title: {
        login: 'Login',
        dashboard: 'Home Page Overview',
        decoration:'Renovation',
        decoration_pc: "DecorationPC",
        decoration_h5: "DecorationMobile",
        role:'VIP Members',
    },
    commen: {
        Locale: "enLocale",
        logintitle:'Home page',
        indextitle: "Home Page Overview",
        operation_management: "Operation Management",
        decoration_pc: "Computer Terminal",
        decoration_h5: "Mobile Terminal",
        micro_page: "Micro Page",
        comment_management: "Comment Management",
        system_configuration:"System Configuration",
        course_management:"Course Management",
        exam_practice:"Exam Practice",
        marketing_center:"Marketing Center",
        user_management:'User Management',
        vip:'VIP Members',
        transaction_management:"Transaction Management",
    },
    login: {
        login: 'Sign in now',
        tipmes1: 'Please enter the administrator account number',
        tipmes2: 'Please enter the password',
        title: 'Login to MeEdu background management',
        langtext: "English",
        username_required: 'Please enter the administrator account number',
        password_required: 'Please enter your password',
    },
    rightmenu:{
        dropdown_editpassword:"Change password",
        dropdown_logout:"Sign out",
        oldpassword:"Old password",
        newpassword:"New password",
        confirm_password:"Confirm password",
        submit:"Submit",
    },
    index: {
        day_income: "Today's revenue",
        yes_income: "Yesterday's",
        day_paid: "Today's paid users",
        yes_paid: "Yesterday's",
        compared_yesterday: "Compared",
        allnum: "Total users",
        month_income: "Monthly income",
        day_increase: "Increase",
        month_increase: "Compared",
        quick_acsess: "Quick access",
        demand_course: "VOD",
        live_course: "Live",
        graphic_course: "Graphic course",
        ebook: "e-book",
        curriculum_path: "Curriculum path",
        testpaper: "test paper",
        statistical_analysis: "Statistical analysis",
        query: 'Query',
        new_registered_users: "New registered users",
        daily_order_creation: "Daily order creation",
        daily_order_payment: "Daily order payment",
        total_dailypayment_orders: "Total daily payment orders",
        start_time: "Start",
        end_time: "End time",
    },
    decoration_pc: {
        tab1: "Home page display",
        tab2: "Slide",
        tab3: "Notice",
    },
    member:{
        btn_add:'Add',
    },
    ...enLocale
}
export default en;